// extracted by mini-css-extract-plugin
export default {"link":"style_link__gRT2k","title":"style_title__duBST","icon":"style_icon__4avJK","deadLink":"style_deadLink__gswjy"};